import { render } from "./addCustomer.vue?vue&type=template&id=5ba98896&scoped=true"
import script from "./addCustomer.vue?vue&type=script&lang=js"
export * from "./addCustomer.vue?vue&type=script&lang=js"

import "./addCustomer.vue?vue&type=style&index=0&id=5ba98896&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ba98896"]])

export default __exports__